import { render, staticRenderFns } from "./OrderDeliveryMethod.vue?vue&type=template&id=7bb4d7e4"
import script from "./OrderDeliveryMethod.vue?vue&type=script&lang=js"
export * from "./OrderDeliveryMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports